import { FunctionComponent } from 'react';
import { ListItemText, Box, IconButton, ListItem } from '@mui/material'
import SkeletonExt from '@/components/layouts/SkeletonExt';
import { Checkbox, InputOnlyField } from '@ngt/forms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faMinus } from '@fortawesome/duotone-light-svg-icons';


interface IConfigurationFormEventSkeleton {}

const ConfigurationFormEventSkeleton: FunctionComponent<IConfigurationFormEventSkeleton> = ({}) => {
    return (
        <ListItem>
            <ListItemText
                primary={
                    <Box
                        sx={{
                            display: 'flex'
                        }}
                    >
                        <InputOnlyField
                            propertyPath={`skeleton`}
                            component={Checkbox}
                            FormControlProps={{
                                fullWidth: false
                            }}
                        />
                        <Box
                            sx={{
                                fontSize: '1.5rem',
                                mr: 2
                            }}
                        >
                            <FontAwesomeIcon fixedWidth icon={faCalendarDays} />
                        </Box>
                        <SkeletonExt variant="text" minWidth={80} maxWidth={120} />
                        <IconButton sx={{ ml: 'auto' }}>
                            <FontAwesomeIcon icon={faMinus} fixedWidth />
                        </IconButton>
                    </Box>
                }
            />
        </ListItem>
    );
}

export default ConfigurationFormEventSkeleton;